<template>

<app-table-cell class="cell-wrapper">

	<div class="label" :data-type="type" :class="{'is-inline': isInline}">{{ text }}<small v-if="subtext">{{ subtext }}</small></div>

</app-table-cell>

</template>

<script>

export default {

	props: ['text', 'subtext', 'type', 'isInline']

}

</script>

<style scoped>

.cell-wrapper {
	padding: 0px;
	border-right: 0px;
}

.label {
	color: #fff;
    font-size: 14px;
	line-height: 16px;
    padding: 3px 6px;
    background-color: #4082d3;
}

.row:hover .label {
	background-color: #316bb3;
}

.label:not(.is-inline) {
    font-weight: 500;
    border-bottom: 1px solid #fff;
    border-radius: 0px;
    width: 100%;
	display: flex;
	padding: 0px 10px;
	justify-content: center;
	min-height: 54px;
	height: 100%;
	flex-direction: column;
}

.label.is-inline {
	line-height: 20px;
	font-weight: 400;
	border-radius: 4px;
}

.row:last-child .label {
	border-bottom: 0px;
}

.label[data-type="grey"] {
	background-color: #939393;
}

.row:hover .label[data-type="grey"] {
	background-color: #7d7d7d;
}

.label[data-type="green"],
.label[data-type="success"] {
	background-color: #4faa80;
}

.row:hover .label[data-type="green"],
.row:hover .label[data-type="success"] {
	background-color: #3e8865;
}

.label[data-type="red"],
.label[data-type="danger"] {
	background-color: #c55b5b;
}

.row:hover .label[data-type="red"],
.row:hover .label[data-type="danger"] {
	background-color: #c94141;
}

.label[data-type="yellow"],
.label[data-type="warning"] {
	background-color: #ffbe7a;
	color: #333;
}

.row:hover .label[data-type="yellow"],
.row:hover .label[data-type="warning"] {
	background-color: #f7a651;
}

.label small {
	display: block;
	font-size: 12px;
	margin-top: 0px;
	opacity: 0.8;
	font-weight: 300;
}

</style>
